import useSwr from "@/core/composables/swr/useSwr";
import {notificationSequenceApi} from "@/container";
import {computed} from "vue";
import {cacheKey} from "@/lib/cache";

/**
 * Composable to get the daily volume of upcoming sequence messages.
 */
const useUpcomingSequenceMessageSummary = (days?: number) => {
    const key = computed(() => {
        return cacheKey('notification-sequence-messages/upcoming-summary', days ? {days} : {});
    });

    return useSwr(
        key,
        () => notificationSequenceApi().upcomingMessagesSummary(days),
    );
};

export default useUpcomingSequenceMessageSummary;
